import { Reveal } from "./Reveal";
import { CtaButtons } from "./Cta";
import { Blob } from "./Decor";

// Final CTA band — solid brand blue, white text.
export default function CtaBanner({
  eyebrow = "Une question ? Un projet ?",
  title = "Un projet de chauffage ? Contactez-nous.",
}) {
  return (
    <section data-testid="cta-banner" className="px-6 py-20 md:px-12 md:py-28">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-[#1A49F7] px-8 py-16 md:px-16 md:py-24">
        <Blob color="#5b7bff" className="-right-20 -top-24" size={360} opacity={0.55} />
        <Blob color="#FC8529" className="-bottom-28 -left-16" size={320} opacity={0.35} />
        <Reveal>
          <div className="relative">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/70">{eyebrow}</p>
            <h2 className="mt-5 max-w-3xl text-4xl font-bold leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
              {title}
            </h2>
            <div className="mt-10">
              <CtaButtons size="lg" dark />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
